/**
 * @generated SignedSource<<a74bf6ccc01a361ee86cecd63c048ce9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutFrame_item$data = {
  readonly serviceId: string | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "CheckoutFrame_item";
};
export type CheckoutFrame_item$key = {
  readonly " $data"?: CheckoutFrame_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFrame_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutFrame_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "a320b9e4b2545ef94044827bd6c9df5d";

export default node;
